export const DIAL_HEIGHT = 75;
export const DIAL_WIDTH = 50;
